import React, { useEffect } from "react";
import { connect } from "react-redux";
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Divider from "@mui/material/Divider";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { cardStyle } from "../../../Dashboard/customStyles";
import { generateDebtPanel } from "../../../../store/modules/dealOffer/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import { primary } from "../../../../assets/colorPallet";
import Item from "../InputItem";

function SourcesAndUses({
  dealType,
  debtPanel,
  dispatchGenerateDebtPanel,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateDebtPanel(dealType);
  }, []);

  return (
    <div className="flex flex-wrap justify-center" style={{ minWidth: 610 }}>
      {debtPanel &&
        (<>
          <Card sx={cardStyle.dealCard}>
            <CardHeader
              sx={{ background: primary}}
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white",  textAlign: "center" }}
              title="Sources of Funds"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <Item name="Cash on Target Balance Sheet" data={debtPanel.cash} disabled={true} />
              <Item name="(-) Minimum Cash Balance" data={debtPanel.minimumCashBalance} disabled={true} />
              {debtPanel.debtArray?.map((debt) => (
                debt.value > 0  && <Item name={debt.name} data={debt.value} disabled={true} />
              ))}
              <Divider />
              <Item name="Total" data={debtPanel.fundsTotal} disabled={true} bold={true} />
            </CardContent>
          </Card>

          <Card sx={{ ...cardStyle.dealCard, minHeight: 550 }}>
            <CardHeader
              sx={{ background: primary}}
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white",  textAlign: "center" }}
              title="Uses of Funds"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <Item name="Purchase Price" data={debtPanel.purchasePrice} disabled={true} />
              <Item name="Target Debt Assumed" data={debtPanel.debtAssumed} disabled={true} />
              <Item name="Transaction Costs, WC & Restructuring Charges" data={debtPanel.transCoAndRest} disabled={true} />
              <Item name="Financing Fee" data={debtPanel.feesTotal} disabled={true} />
              <Divider />
              <Item name="Total" data={debtPanel.fundsTotal} disabled={true} bold={true} />
            </CardContent>
          </Card>

          <Card sx={{ ...cardStyle.dealCard, minHeight: 550 }}>
            <CardHeader
              sx={{ background: primary}}
              titleTypographyProps={{ fontSize: 40, fontWeight: 700, color: "white",  textAlign: "center" }}
              title="Debt / Equity Ratio"
            />
            <CardContent sx={{ padding: "20px 30px" }}>
              <Item name="Debt (Including Owner Finance)" data={debtPanel.debtInclude} disabled={true} />
              <Item name="Debt (Excluding Owner Finance)" data={debtPanel.debtExclude} disabled={true} />
              <Item name="Equity" data={debtPanel.sponsorEquity} disabled={true} />
              <Item name="Ratio (Including Owner Finance)" data={debtPanel.ratioInclude} endLabel = "%" disabled={true} />
              <Item name="Ratio (Excluding Owner Finance)" data={debtPanel.ratioExclude} endLabel = "%" disabled={true} />
            </CardContent>
          </Card>
          
        </>)
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  debtPanel: state.dealOffer.debtPanel,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateDebtPanel(dealType) {
    await dispatch(generateDebtPanel(dealType));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SourcesAndUses);
